export const KEYWORD = {
  NOT: /^not /,
  EXTENDS: /^extends /,
}
export const TOKEN_TYPE = {
  NOT: 'not',
  EXTENDS: 'extends',
  PERMIT_ALL: 'permit_all',
  RESOURCE: 'resource',
  PERMISSION: 'permission',
  ROLE: 'role',
}
